import { Button, Divider, Drawer, Table, Typography } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { UserInfo } from "../../../../context";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import _ from "lodash";

const MerchantEmployeeReportOrderDetails = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const [totalCost, setTotalCost] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalPerProd, setTotalPerProd] = useState(0);
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [newOrderDetailsList, setNewOrderDetailsList] = useState({
    data: [],
    ready: false,
  });

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      // dataIndex: "product",
      render: (text, record) => (
        <p>
          {text.product}
          {parseInt(text.is_per_piece) === 0 && ` - ${text.quantity}gram(s)`}
        </p>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    userData.data.usersmerchantemployee.perproductcost !== null && {
      title: userData.data.usersmerchantemployee.perproductcost.description,
      align: "right",
      // dataIndex: "cost_per_prod",
      render: (text) => (
        <p>
          &#8369;
          {parseFloat(
            parseInt(text.is_per_piece) === 0
              ? text.cost_per_prod
              : text.cost_per_prod * text.quantity
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "Price x Qty",
      align: "right",
      render: (text, record) => (
        <>
          {parseInt(text.is_per_piece) === 1 ? (
            <p style={{ minWidth: 80, textAlign: "right" }}>
              &#8369;{text.price} x {text.quantity}
            </p>
          ) : (
            <p style={{ minWidth: 80, textAlign: "right" }}>
              &#8369;{text.price}
            </p>
          )}
        </>
        // <>
        //   &#8369;{text.price} x {text.quantity}
        // </>
      ),
    },
  ];
  const columns2 = [
    {
      title: "Product",
      dataIndex: "product",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    userData.data.usersmerchantemployee.perproductcost !== null && {
      title: userData.data.usersmerchantemployee.perproductcost.description,
      align: "right",
      // dataIndex: "cost_per_prod",
      render: (text) => (
        <p>
          &#8369;
          {parseFloat(
            parseInt(text.is_per_piece) === 0
              ? text.cost_per_prod
              : text.cost_per_prod * text.quantity
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "Price",
      align: "right",
      render: (text, record) => <>&#8369;{text.price}</>,
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const tableColumns2 = columns2.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantOrderDetails = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
      transaction_id: selectedData !== null ? selectedData.transaction_id : "",
      order_category: "all",
    };
    axios
      .get("user/merchant/spec-transaction-info", {
        params,
      })
      .then((response) => {
        const data = response.data;

        const res = _.chain(data)
          .groupBy((g) => g.order_category)
          .map((value, key) => ({
            order_category: key,
            data: value,
            total: consumptionTotal(value),
            discount: calculateDiscount(value),
            perproduct: calculatePerProdCost(value),
          }))
          .value();
        setNewOrderDetailsList({ data: res, ready: true });

        setOrderDetailsList({ data, ready: true });
        setTotalCost(calculateTotal(data));
        setTotalDiscount(calculateDiscount(data));
        setTotalPerProd(calculatePerProdCost(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id, selectedData]);

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      // total += parseFloat(data[i].quantity) * parseFloat(data[i].price);
      total +=
        parseFloat(data[i].is_per_piece) === 1
          ? parseFloat(data[i].quantity) *
            parseFloat(data[i].price.replace(",", ""))
          : parseFloat(data[i].price.replace(",", ""));
    }
    return total;
  };

  const consumptionTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        data[i].service_type === "consumable"
          ? parseFloat(data[i].price) * 1
          : parseFloat(data[i].quantity) * parseFloat(data[i].price);
    }
    return total;
  };

  const calculateDiscount = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseFloat(data[i].discount_amount) * 1;
    }
    return total;
  };

  const calculatePerProdCost = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        parseFloat(
          data[i].cost_per_prod !== null
            ? parseInt(data[i].is_per_piece) === 0
              ? data[i].cost_per_prod
              : data[i].cost_per_prod * data[i].quantity
            : 0
        ) * 1;
    }
    return total;
  };

  useEffect(() => {
    getMerchantOrderDetails();
  }, [getMerchantOrderDetails]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
    },
  });

  return (
    <Drawer
      title="Receipt"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <div>
          <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
          >
            Print
          </Button>
        </div>
      }
    >
      {selectedData !== null && (
        <>
          <div
            style={{ overflowX: "auto", padding: paddingPrint }}
            ref={componentRef}
          >
            <div
              style={{
                display: "flex",
                // flexDirection: "column",
                paddingRight: 15,
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <div style={{ flexGrow: 1 }}>
                <Typography
                  style={{
                    //  fontWeight: "bold",
                    fontSize: 14,
                  }}
                >
                  Customer Name:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {orderDetailsList.ready &&
                      orderDetailsList.data[0].customer_name}
                  </span>
                </Typography>
                <Typography
                  style={{
                    // fontWeight: "bold",
                    fontSize: 14,
                    display:
                      orderDetailsList.ready &&
                      orderDetailsList.data[0].table_no !== "Table #"
                        ? "block"
                        : "none",
                  }}
                >
                  {/* {allowDineSetup ? "Location" : "Table Number"}:{" "} */}
                  Location:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {orderDetailsList.ready &&
                      orderDetailsList.data[0].table_no}
                  </span>
                </Typography>
                <Typography
                  style={{
                    fontSize: 14,
                    display:
                      orderDetailsList.ready &&
                      orderDetailsList.data[0].contact_no !== null
                        ? "block"
                        : "none",
                  }}
                >
                  Customer #:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {orderDetailsList.ready &&
                      orderDetailsList.data[0].contact_no}
                  </span>
                </Typography>
                <Typography
                  style={{
                    fontSize: 14,
                    display:
                      orderDetailsList.ready &&
                      orderDetailsList.data[0].customer_address !== null
                        ? "block"
                        : "none",
                  }}
                >
                  Customer Address:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {orderDetailsList.ready &&
                      orderDetailsList.data[0].customer_address}
                  </span>
                </Typography>
                <Typography
                  style={{
                    // fontWeight: "bold",
                    fontSize: 14,
                    textTransform: "capitalize",
                  }}
                >
                  Status:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {orderDetailsList.ready &&
                      orderDetailsList.data[0].service_category}
                  </span>
                </Typography>
                <Typography
                  style={{
                    // fontWeight: "bold",
                    fontSize: 14,
                    textTransform: "capitalize",
                    // marginBottom: 10,
                  }}
                >
                  Transaction #:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {orderDetailsList.ready &&
                      orderDetailsList.data[0].transaction_id}
                  </span>
                </Typography>

                {orderDetailsList.ready &&
                  orderDetailsList.data[0].service_type !== null && (
                    <Typography
                      style={{
                        // fontWeight: "bold",
                        fontSize: 14,
                        textTransform: "capitalize",
                        // marginBottom: 10,
                      }}
                    >
                      Service Type:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {orderDetailsList.data[0].service_type}
                      </span>
                    </Typography>
                  )}

                {orderDetailsList.ready &&
                  orderDetailsList.data[0].payment_method !== null && (
                    <Typography
                      style={{
                        fontSize: 14,
                      }}
                    >
                      Payment Method:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {orderDetailsList.data[0].payment_method === "ecash"
                          ? `E-Cash (${orderDetailsList.data[0].noncash})`
                          : orderDetailsList.data[0].payment_method === "cash"
                          ? "Cash"
                          : "Split Payment"}
                      </span>
                    </Typography>
                  )}

                {orderDetailsList.ready &&
                  orderDetailsList.data[0].e_ref_no !== null && (
                    <Typography
                      style={{
                        fontSize: 14,
                      }}
                    >
                      Reference #:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {orderDetailsList.data[0].e_ref_no}
                      </span>
                    </Typography>
                  )}
              </div>
              <div>
                {orderDetailsList.ready &&
                  orderDetailsList.data[0].customerordercashiered !== null && (
                    <Typography
                      style={{
                        fontSize: 14,
                      }}
                    >
                      Cashiered By:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {orderDetailsList.ready &&
                          orderDetailsList.data[0].customerordercashiered
                            .firstname}
                      </span>
                    </Typography>
                  )}
                {orderDetailsList.ready &&
                  orderDetailsList.data[0].customerorderdispatched !== null && (
                    <Typography
                      style={{
                        fontSize: 14,
                      }}
                    >
                      Dispatched By:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {orderDetailsList.ready &&
                          orderDetailsList.data[0].customerorderdispatched
                            .firstname}
                      </span>
                    </Typography>
                  )}

                {orderDetailsList.ready &&
                  orderDetailsList.data[0].customerorderserved !== null && (
                    <Typography
                      style={{
                        fontSize: 14,
                      }}
                    >
                      Served By:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {orderDetailsList.ready &&
                          orderDetailsList.data[0].customerorderserved
                            .firstname}
                      </span>
                    </Typography>
                  )}
              </div>
            </div>

            {orderDetailsList.ready &&
            orderDetailsList.data[0].service_type === "consumable" ? (
              <>
                {newOrderDetailsList.ready &&
                  newOrderDetailsList.data.map((data, index) => (
                    <div key={index}>
                      <Divider>
                        {data.order_category === "additional-service"
                          ? "Service"
                          : "Products"}
                      </Divider>
                      <Table
                        {...tableProps}
                        pagination={false}
                        columns={
                          data.order_category === "additional-service"
                            ? tableColumns2
                            : tableColumns
                        }
                        dataSource={data.data.length > 0 ? data.data : []}
                        scroll={scroll}
                        rowKey={(record) => record.id}
                        expandable={{
                          expandedRowRender: (record) => (
                            <p style={{ margin: 0 }}>
                              Discount by
                              {/* {console.log("record", record)} */}
                              {record.discount_category === "percentage"
                                ? `(${record.price} * ${record.discount_percentage}%) * ${record.discount_quantity} = ${record.discount_amount}`
                                : `${record.discount_amount}`}
                            </p>
                          ),
                          rowExpandable: (record) =>
                            record.discount_category !== null,
                        }}
                        footer={() => (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{ flexGrow: 1, fontWeight: "bold" }}
                            ></div>
                            <Typography style={{ textAlign: "right" }}>
                              Total:{" "}
                              {parseFloat(
                                data.total + data.perproduct
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                            {data.discount !== 0 && (
                              <>
                                <Typography style={{ textAlign: "right" }}>
                                  Discount:{" "}
                                  {data.discount.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Typography>
                                <Typography style={{ textAlign: "right" }}>
                                  Grand Total:{" "}
                                  {parseFloat(
                                    data.total + data.perproduct - data.discount
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Typography>
                              </>
                            )}
                          </div>
                        )}
                      />
                    </div>
                  ))}

                <div
                  style={{ display: "flex", paddingRight: 15, marginTop: 10 }}
                >
                  <div style={{ flexGrow: 1 }} />
                  <div>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        fontSize: 14,
                        textAlign: "right",
                      }}
                    >
                      Total Cost: &#8369;
                      {parseFloat(
                        newOrderDetailsList.data.length > 1
                          ? parseFloat(
                              newOrderDetailsList.data[0].total +
                                newOrderDetailsList.data[0].perproduct -
                                newOrderDetailsList.data[0].discount
                            ) >
                            parseFloat(
                              newOrderDetailsList.data[1].total +
                                newOrderDetailsList.data[1].perproduct -
                                newOrderDetailsList.data[1].discount
                            )
                            ? newOrderDetailsList.data[0].total +
                              newOrderDetailsList.data[0].perproduct -
                              newOrderDetailsList.data[0].discount
                            : newOrderDetailsList.data[1].total +
                              newOrderDetailsList.data[1].perproduct -
                              newOrderDetailsList.data[1].discount
                          : newOrderDetailsList.data[0].total +
                              newOrderDetailsList.data[0].perproduct -
                              newOrderDetailsList.data[0].discount
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                  </div>
                </div>
                <div style={{ display: "flex", paddingRight: 15 }}>
                  <div style={{ flexGrow: 1 }} />
                  <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                    Payment: &#8369;
                    {parseFloat(
                      parseFloat(
                        orderDetailsList.ready &&
                          orderDetailsList.data[0].payment
                      ) +
                        parseFloat(
                          orderDetailsList.ready &&
                            orderDetailsList.data[0].epayment
                        )
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </div>
                {orderDetailsList.ready &&
                  orderDetailsList.data[0].payment_method === "split-cash" && (
                    <>
                      <div style={{ display: "flex", paddingRight: 15 }}>
                        <div style={{ flexGrow: 1 }} />
                        <Typography
                          style={{ fontWeight: "bold", fontSize: 14 }}
                        >
                          Cash: &#8369;
                          {parseFloat(
                            orderDetailsList.ready &&
                              orderDetailsList.data[0].payment
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </Typography>
                      </div>

                      <div style={{ display: "flex", paddingRight: 15 }}>
                        <div style={{ flexGrow: 1 }} />
                        <Typography
                          style={{ fontWeight: "bold", fontSize: 14 }}
                        >
                          ECash: &#8369;
                          {parseFloat(
                            orderDetailsList.ready &&
                              orderDetailsList.data[0].epayment
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </Typography>
                      </div>
                    </>
                  )}
                <div style={{ display: "flex", paddingRight: 15 }}>
                  <div style={{ flexGrow: 1 }} />
                  <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                    Change: &#8369;
                    {(
                      parseFloat(
                        parseFloat(
                          orderDetailsList.ready &&
                            orderDetailsList.data[0].payment
                        ) +
                          parseFloat(
                            orderDetailsList.ready &&
                              orderDetailsList.data[0].epayment
                          )
                      ) -
                      parseFloat(
                        newOrderDetailsList.data.length > 1
                          ? parseFloat(
                              newOrderDetailsList.data[0].total +
                                newOrderDetailsList.data[0].perproduct -
                                newOrderDetailsList.data[0].discount
                            ) >
                            parseFloat(
                              newOrderDetailsList.data[1].total +
                                newOrderDetailsList.data[1].perproduct -
                                newOrderDetailsList.data[1].discount
                            )
                            ? newOrderDetailsList.data[0].total +
                              newOrderDetailsList.data[0].perproduct -
                              newOrderDetailsList.data[0].discount
                            : newOrderDetailsList.data[1].total +
                              newOrderDetailsList.data[1].perproduct -
                              newOrderDetailsList.data[1].discount
                          : newOrderDetailsList.data[0].total +
                              newOrderDetailsList.data[0].perproduct -
                              newOrderDetailsList.data[0].discount
                      )
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </div>
              </>
            ) : (
              <>
                <Table
                  {...tableProps}
                  pagination={false}
                  columns={tableColumns}
                  dataSource={
                    orderDetailsList.data.length > 0
                      ? orderDetailsList.data
                      : []
                  }
                  scroll={scroll}
                  rowKey={(record) => record.id}
                  expandable={{
                    expandedRowRender: (record) => (
                      <p style={{ margin: 0 }}>
                        Discount by{" "}
                        {record.discount_category === "percentage"
                          ? `(${record.price} * ${record.discount_percentage}%) * ${record.discount_quantity} = ${record.discount_amount}`
                          : `${record.discount_amount}`}
                      </p>
                    ),
                    rowExpandable: (record) =>
                      record.discount_category !== null,
                  }}
                />

                <div
                  style={{ display: "flex", paddingRight: 15, marginTop: 10 }}
                >
                  <div style={{ flexGrow: 1 }} />
                  <div>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        fontSize: 14,
                        textAlign: "right",
                      }}
                    >
                      Total Cost: &#8369;
                      {totalCost.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>

                    {userData.data.usersmerchantemployee.perproductcost !==
                      null && (
                      <Typography
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          textAlign: "right",
                        }}
                      >
                        Total{" "}
                        {
                          userData.data.usersmerchantemployee.perproductcost
                            .description
                        }
                        : &#8369;
                        {totalPerProd.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Typography>
                    )}
                    {totalDiscount > 0 && (
                      <Typography
                        style={{
                          fontWeight: "bold",
                          fontSize: 14,
                          textAlign: "right",
                        }}
                      >
                        Discount: &#8369;
                        {totalDiscount.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Typography>
                    )}
                    <Typography
                      style={{
                        fontWeight: "bold",
                        fontSize: 14,
                        textAlign: "right",
                      }}
                    >
                      Grand Total: &#8369;
                      {parseFloat(
                        totalCost + totalPerProd - totalDiscount
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                  </div>
                </div>
                <div style={{ display: "flex", paddingRight: 15 }}>
                  <div style={{ flexGrow: 1 }} />
                  <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                    Payment: &#8369;
                    {parseFloat(
                      parseFloat(
                        orderDetailsList.ready &&
                          orderDetailsList.data[0].payment
                      ) +
                        parseFloat(
                          orderDetailsList.ready &&
                            orderDetailsList.data[0].epayment
                        )
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </div>
                {orderDetailsList.ready &&
                  orderDetailsList.data[0].payment_method === "split-cash" && (
                    <>
                      <div style={{ display: "flex", paddingRight: 15 }}>
                        <div style={{ flexGrow: 1 }} />
                        <Typography
                          style={{ fontWeight: "bold", fontSize: 14 }}
                        >
                          Cash: &#8369;
                          {parseFloat(
                            orderDetailsList.ready &&
                              orderDetailsList.data[0].payment
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </Typography>
                      </div>

                      <div style={{ display: "flex", paddingRight: 15 }}>
                        <div style={{ flexGrow: 1 }} />
                        <Typography
                          style={{ fontWeight: "bold", fontSize: 14 }}
                        >
                          ECash: &#8369;
                          {parseFloat(
                            orderDetailsList.ready &&
                              orderDetailsList.data[0].epayment
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </Typography>
                      </div>
                    </>
                  )}
                <div style={{ display: "flex", paddingRight: 15 }}>
                  <div style={{ flexGrow: 1 }} />
                  <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                    Change: &#8369;
                    {(
                      parseFloat(
                        parseFloat(
                          orderDetailsList.ready &&
                            orderDetailsList.data[0].payment
                        ) +
                          parseFloat(
                            orderDetailsList.ready &&
                              orderDetailsList.data[0].epayment
                          )
                      ) - parseFloat(totalCost + totalPerProd - totalDiscount)
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </Drawer>
  );
};

export default MerchantEmployeeReportOrderDetails;
